import { useComplexQuery } from '@sequencehq/api'
import {
  dashboard20240730Client,
  DashboardApi20240730
} from '@sequencehq/api/dashboard/v20240730'

type LineItemGroupUsageData =
  DashboardApi20240730.GetUsageDataForInvoiceLineItemGroup.LineItemGroupUsageData

const loadLineItemGroupsUsageData = async ({
  invoiceId,
  lineItemGroupIds
}: {
  invoiceId: string
  lineItemGroupIds: string[]
}) => {
  const results = await Promise.all(
    lineItemGroupIds.map(async lineItemGroupId => {
      return await dashboard20240730Client.getUsageDataForInvoiceLineItemGroup({
        invoiceId,
        lineItemGroupId
      })
    })
  )

  return results
    .map(result => result.data?.data)
    .filter((obj): obj is LineItemGroupUsageData => Boolean(obj))
}

export const useLineItemGroupsUsageData = ({
  invoiceId,
  lineItemGroupIds
}: {
  invoiceId: string
  lineItemGroupIds: string[]
}) => {
  return useComplexQuery({
    queryKey: [
      ...dashboard20240730Client.getUsageDataForInvoiceLineItemGroup.queryKey,
      'CUSTOM:useLineItemGroupsUsageData',
      JSON.stringify(lineItemGroupIds)
    ],
    queryFn: () => loadLineItemGroupsUsageData({ invoiceId, lineItemGroupIds }),
    enabled: !!invoiceId
  })
}
